import React from 'react';

const ConfigSystemFormModal = React.lazy(() => import('../components/FormModal'));
const configSystemModalRegistry = {
    core_configSystemId: ConfigSystemFormModal
};
export default configSystemModalRegistry;
